"use strict";
import {
    HubConnectionBuilder,
    LogLevel
} from '@microsoft/signalr'
export default {
    install(Vue) {
        const connection = new HubConnectionBuilder()
            .withUrl('https://sock.larepublica.co/refresh')
            .configureLogging(LogLevel.Error)
            .withAutomaticReconnect()
            .build();
        const refreshHub = new Vue();
        Vue.prototype.$refreshHub = refreshHub;
        connection.on('RefreshHome', () => {
            refreshHub.$emit('home-refreshed');
        });

        connection.on('RefreshLive', () => {
            refreshHub.$emit('live-refreshed');
        });
    }
}